<template>
  <div :class="['uploader-comp','rel', hasErr ? 'err' : '', locale == 'HE' ? 'rtl':'']">
    <p v-if="note" v-text="note" class="note mb-m"></p>
    <file-pond
      v-bind:labelFileProcessing = "localize('uploading')"
      v-bind:labelFileProcessingComplete = "localize('upload_complete')"
      v-bind:labelTapToCancel = "localize('tap_to_cancel')"
      v-bind:labelTapToUndo = "localize('tap_to_undo')"
      name="gallery"
      ref="pond"
      class="locale-content mt-med mb-med"
      v-bind:labelIdle="getInputLabel"
      :accepted-file-types="acceptedFileTypes || null"
      :allow-multiple="true"
      :server="serverOptions"
      :files="myFiles"
      @init="handleFilePondInit"
      @addfilestart="fileStarted"
      @processfile="fileProcessed"
      @processfiles="filesProcessed"
    />
    <span v-if="hasErr" :class="['err l-0 err-msg pl-l']">
      * {{localize('this_fileld_required')}}
    </span>
    <span class="text-gray-6 font-bd mr-s upload-note"
      >{{localize('max_file_size')}}</span
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// Import Vue FilePond
import vueFilePond from "vue-filepond";
// Import FilePond styles
// Import FilePond plugins

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// // Create component
vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
// console.log("FILEPOND > ", FilePond);
export default {
  props: {
    note: String,
    locale: {
      type: String,
      default: 'EN'
    },
    req: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: "uploader-1"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    // Should this uploader be validated...
    willValidate: {
      type: Boolean,
      default: false
    },
    acceptedFileTypes: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      fileBatchId: null,
      colorPickerActive: false,
      myFiles: [],
      filesReady: [],
      filesProcessing: [],
      filesList: []
    };
  },
  mounted() {
    if (this.willValidate) {
      this.$emit("validate-field", this.name, !!this.filesList.length);
    }
  },
  destroyed() {
    this.$emit("remove-validation", this.name);
  },
  watch: {
    willValidate() {
      if (this.willValidate) {
        this.$emit("validate-field", this.name, !!this.filesList.length);
      } else {
        this.$emit("remove-validation", this.name);
      }
    },
    filesList() {
      if (this.filesList.length) {
        this.$emit("validate-field", this.name, true);
      }
    }
  },
  methods: {
    handleFilePondInit: function() {
      // console.log("FilePond has initialized");
    },
    fileAddedCB(file, b) {
      console.log("FILE ADDED >> ", file, b);
    },
    fileStarted(file) {
      console.log("file started > ", file);
      this.filesProcessing.push(file.id);
      if (!this.fileBatchId) {
        this.fileBatchId = new Date().getTime();
      }
    },
    filesProcessed(e, file) {
      let vm = this;
      console.log("filesProcessed >> ", e, file);
      let DOM_files = document.querySelectorAll(
        ".filepond--action-revert-item-processing"
      );
      DOM_files.forEach(item => {
        item.addEventListener("click", event => {
          console.log("event: ", event);
          let OriginFileName =
            event.target.parentNode.parentElement.firstElementChild.textContent;
          console.log("OriginFileName: ", OriginFileName, " >>> ", vm);
          vm.$emit("remove-media-file", OriginFileName);
          _.remove(vm.filesList, { OriginFileName });

          // this.fileRemove(file.id);
          //handle click
        });
      });
      // .addEventListener("click", function(e) {
      //         console.log('e: ', e);

      //       })
      this.$emit("update-media-files", this.filesList);
      this.clearProcessedFiles();
    },

    fileProcessed(a, file) {
      // let vm = this;
      console.log("fileProcessed > ", a, file);
      this.filesReady.push(file);
    },
    clearProcessedFiles() {
      this.filesReady = [];
      this.filesProcessing = [];
    },
    fileRemove(id) {
      console.log("removed: ", id);
      this.filesReady.splice(this.filesProcessing.indexOf(id), 1);
      this.filesProcessing.splice(this.filesProcessing.indexOf(id), 1);
    }
  },
  computed: {
    ...mapGetters(["userToken", "userID"]),
    getInputLabel()
    {
      return this.localize('drop_your_files')+'<span class="filepond--label-action"> '+this.localize('upload')+' <i class="fal fa-chevron-right"></i> </span>';
      //return 'Drop your files here or click the upload button <span class="filepond--label-action"> Upload <i class="fal fa-chevron-right"></i> </span>';
    },
    hasErr() {
      return (
        (this.req || this.willValidate) && this.dirty && !this.filesList.length
      );
    },
    filesProcessingString() {
      let p = _.map(this.filesReady, "id");
      return p.toString();
    },
    serverOptions() {
      var vm = this;
      return {
        process: {
          url: `${SERVER_API[ENV]}mflow/OrderFileUpload`,
          headers: {
            "batch-id": this.fileBatchId,
            "file-amount": this.filesProcessing.length,
            "file-ids": this.filesProcessingString,
            t: this.userToken,
            u: this.userID,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'x-token':this.userToken,
            'x-mid':this.userID
          },
          onload(file) {
            console.log("FILE loaded < ", file);
            console.log("media files < ", vm);
            vm.filesList.push(JSON.parse(file)[0]);
            // vm.$set(
            //   vm.order,
            //   "MediaFiles",
            //   _.map(vm.order.MediaFiles, (item, i) => {
            //     return _.merge(item, file[i]);
            //   })
            // );
          },
          oncomplete(file) {
            console.log("FILE COMPLET< ", file);
          }
        },

        revert: (uniqueFileId, load, error) => {
          console.log("uniqueFileId: ", uniqueFileId);
          // Should remove the earlier created temp file here
          // ...

          // Can call the error method if something is wrong, should exit after
          error("oh my goodness");

          // Should call the load method when done, no parameters required
          load();
        }
        // revert: {
        //   url: `${SERVER_API[ENV]}mflow/OrderFileUpload`,
        //   onerror(e, b) {
        //     console.log("err e,b: ", e, b);
        //     // FILE HAS BEEN REMOVE @ CLIENT
        //   },
        //   ondata(e, b) {
        //     console.log("ondata e,b: ", e, b);
        //     // FILE HAS BEEN REMOVE @ CLIENT
        //   },
        //   onload(e, b) {
        //     console.log("load e,b: ", e, b);
        //     console.log(" e,b: ", e, b);
        //   },
        //   oncomplete(e, b) {
        //     console.log("complete e,b: ", e, b);
        //   }
        // }
      };
    }
  }
};
</script>

<style>
  .uploader-comp.rtl .filepond--drop-label
  {
    direction: rtl !important;    
  }
  .uploader-comp.rtl .filepond--label-action
  {
    left: 0px;
    right: initial;
  }
  .uploader-comp.rtl .filepond--label-action i 
  {
      transform: translateX(-5px) rotate(180deg);
  }
  
</style>

<style lang="stylus">
.uploader-comp.rtl
  .err
    transform translateY(6px)
    text-align left
.upload-note
  position absolute
  right 0
  top 103%
  font-size 11px
.filepond--root
  .filepond--panel-root
    background none
  .filepond--list-scroller
    margin-top 3em
.filepond--drop-label
  overflow hidden
  border-radius 22px
  position relative
  border 1px solid gray_4
  background #fff
  justify-content flex-start
  min-height 44px !important
  pad('s', left)
  /.err &
    border-color red_4
  & > label
    padding 0
    color gray_5
    font-size responsive 14px 15px

.filepond--label-action
  background blue_brand
  display block
  position absolute
  right 0
  top 0
  height 100%
  color #fff
  line-height 44px
  padding 0 20px
  text-decoration none
  transition background 0.2s ease-out
  outline 0
  selection none
  i
    display inline-block
    transform translateX(0)
    marg('xs', left)
    transition transform 0.2s ease-in-out-back
  &:hover
    background lighten(blue_brand, 10)
    i
      transform translateX(25%)

[data-filepond-item-state="processing-complete"] .filepond--item-panel
  background darken(blue_brand, 20)
[data-filepond-item-state*='invalid'] .filepond--item-panel, [data-filepond-item-state*='error'] .filepond--item-panel
  background red_7

.filepond--credits
  display none
</style>
